export const titlesHtmlHead = {
    "/inicio": "Inicio",
    "/dashboard/general": "Dashboard - General",
    "/dashboard/presupuestos": "Dashboard - Presupuestos",
    "/dashboard/solicitud-venta": "Dashboard - Solicitud de ventas",
    "/dashboard/facturacion": "Dashboard - Facturación",
    "/dashboard/stock": "Dashboard - Stock",
    "/clientes": "Clientes - Listado",
    "/clientes/crear": "Clientes - Crear",
    "/car-catalogo": "Producto - Listado",
    "/stock/stock-main": "Stock - Listado",
    "/stock/carga-masiva": "Stock - Carga masiva",
    "/stock/gestion-de-usados": "Stock - Gestión de usados",
    "/catalogo": "Catálogo - Listado",
    "/catalogo/carDetail": "Catálogo - Detalle de producto",
    "/comparador": "Comparador",
    "/presupuestador/lista": "Presupuestador - Listado",
    "/presupuestador/crear": "Presupuestador - Crear",
    "/solicitud-venta": "Solicitud de ventas - Listado",
    "/pagos": "Pagos - Listado",
    "/peritador": "Peritador - Listado",
    "/cotizador/nueva": "Cotizador - Nueva cotización",
    "/cotizador": "Cotizador - Listado",
    "/politicas-de-precios": "Políticas de precio",
    "/comisiones/lista": "Comisiones - Listado",
    "/comisiones/politicas": "Comisiones - Políticas",
    "/comisiones/politicas/crear": "Comisiones - Crear",
    "/simulador-financiero": "Líneas financieras - Listado",
    "/simulador-financiero/alta-de-linea": "Líneas financieras - Nueva",
    "/gastos-gestoria": "Gastos de gestoría",
    "/gestión-datos/concesionarios": "Gestión de datos - Concesionario",
    "/gestión-datos/sucursales": "Gestión de datos - Sucursales",
    "/gestión-datos/ubicaciones-fisicas": "Gestión de datos - Ubicación física",
    "/gestión-datos/unidades-de-negocio": "Gestión de datos - Unidades de negocio",
    "/gestión-datos/cuentas-bancarias": "Gestión de datos - Cuentas bancarias",
    "/gestión-datos/legales": "Gestión de datos - Legales",
    "/gestión-datos/tipos-de-cambio": "Gestión de datos - Tipo de cambio",
    "/gestión-datos/entidad-otorgante": "Gestión de datos - Entidades financieras",
    "/gestión-datos/meses-comisionales": "Gestión de datos - Meses comisionales",
    "/gestión-datos/colores": "Gestión de datos - Colores",
    "/usuarios": "Gestión de cuentas - Usuarios",
    "/usuarios/crear": "Gestión de cuentas - Usuarios crear",
    "/cotizador/segmento": "Pautas de cotización - Segmento",
    "/cotizador/antiguedades": "Pautas de cotización - Antigüedades",
    "/cotizador/grilla": "Pautas de cotización - Grilla de quita",
    "/cotizador/categorizacion": "Pautas de cotización - Categorización",
    "/precio-justo/search": "Precio justo - Búsqueda",
    "/precio-justo/batch": "Precio justo - Procesamiento masivo",
    "/precio-justo/dictionaries": "Precio justo procesamiento - Diccionario",
}